// @ts-nocheck
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import StoreCheckoutReviewAndSubmitState from "@store/Framework/Store/Store/Pages/CheckoutReviewAndSubmit/StoreCheckoutReviewAndSubmitState";
import { Draft } from "immer";

const initialState: StoreCheckoutReviewAndSubmitState = {
    useSplitShipping: false,
    shippingDeliveryInstruction: "",
    shippingIsConstructionSite: false,
    shippingLeaveAtDoor: false,
    shippingPhoneNumber: "",
    shippingPhoneNumberHasError: false,
    useShippingNotification: false,
    shippingNotificationEmail: "",
    shippingNotificationEmailHasError: false,
    shippingDeliveryInstructionHasError: false,
};

const actions = {
    "Store/Pages/CheckoutReviewAndSubmit/SetUseSplitShipping": (
        draft: Draft<StoreCheckoutReviewAndSubmitState>,
        action: { useSplitShipping: boolean },
    ) => {
        draft.useSplitShipping = action.useSplitShipping;
    },
    "Store/Pages/CheckoutReviewAndSubmit/SetShippingDeliveryInstruction": (
        draft: Draft<StoreCheckoutReviewAndSubmitState>,
        action: { shippingDeliveryInstruction: string },
    ) => {
        draft.shippingDeliveryInstruction = action.shippingDeliveryInstruction;
    },
    "Store/Pages/CheckoutReviewAndSubmit/SetShippingDeliveryInstructionHasError": (
        draft: Draft<StoreCheckoutReviewAndSubmitState>,
        action: { shippingDeliveryInstructionHasError: boolean },
    ) => {
        draft.shippingDeliveryInstructionHasError = action.shippingDeliveryInstructionHasError;
    },
    "Store/Pages/CheckoutReviewAndSubmit/SetShippingIsConstructionSite": (
        draft: Draft<StoreCheckoutReviewAndSubmitState>,
        action: { shippingIsConstructionSite: boolean },
    ) => {
        draft.shippingIsConstructionSite = action.shippingIsConstructionSite;
    },
    "Store/Pages/CheckoutReviewAndSubmit/SetShippingLeaveAtDoor": (
        draft: Draft<StoreCheckoutReviewAndSubmitState>,
        action: { shippingLeaveAtDoor: boolean },
    ) => {
        draft.shippingLeaveAtDoor = action.shippingLeaveAtDoor;
    },
    "Store/Pages/CheckoutReviewAndSubmit/SetShippingPhoneNumber": (
        draft: Draft<StoreCheckoutReviewAndSubmitState>,
        action: { shippingPhoneNumber: string },
    ) => {
        draft.shippingPhoneNumber = action.shippingPhoneNumber;
    },
    "Store/Pages/CheckoutReviewAndSubmit/SetShippingPhoneNumberHasError": (
        draft: Draft<StoreCheckoutReviewAndSubmitState>,
        action: { shippingPhoneNumberHasError: boolean },
    ) => {
        draft.shippingPhoneNumberHasError = action.shippingPhoneNumberHasError;
    },
    "Store/Pages/CheckoutReviewAndSubmit/SetUseShippingNotification": (
        draft: Draft<StoreCheckoutReviewAndSubmitState>,
        action: { useShippingNotification: boolean },
    ) => {
        draft.useShippingNotification = action.useShippingNotification;
    },
    "Store/Pages/CheckoutReviewAndSubmit/SetShippingNotificationEmail": (
        draft: Draft<StoreCheckoutReviewAndSubmitState>,
        action: { shippingNotificationEmail: string },
    ) => {
        draft.shippingNotificationEmail = action.shippingNotificationEmail;
    },
    "Store/Pages/CheckoutReviewAndSubmit/SetShippingNotificationEmailHasError": (
        draft: Draft<StoreCheckoutReviewAndSubmitState>,
        action: { shippingNotificationEmailHasError: boolean },
    ) => {
        draft.shippingNotificationEmailHasError = action.shippingNotificationEmailHasError;
    },
    "Store/Pages/CheckoutReviewAndSubmit/Reset": () => {
        return initialState;
    },
};

const reducer = createTypedReducerWithImmer(initialState, actions);
export type StoreCheckoutReviewAndSubmitActions = Parameters<typeof reducer>[1];
export default reducer;
